import React from "react";
import { Drawer, DrawerContent } from "@progress/kendo-react-layout";
import { useEmailRules } from "./EmailRulesContext";
import "./RuleForm.scss";
import { ActionsSection, ConditionsSection, FormFooter, FormHeader, LocationsSection, NameField } from "./formSections";
import { useRuleForm } from "./ruleForm.hook";

/**
 * Main component for creating and editing email rules
 * PC : RuleList
 * @author Sarthak Arora
 */
const RuleForm = ({ isOpen, onClose, onSubmit, editingRule = null }) => {
  const { workflowId, actions, handleDelete, handleUpdate, refreshRules } = useEmailRules();

  const { formData, setFormData, errors, isActionSelected, handleLocationChange, handleActionChange, handleConditionChange, handleConditionToggle, nameChangeHandler, handleSubmit } = useRuleForm(
    editingRule,
    {
      workflowId,
      handleUpdate,
      refreshRules,
      onClose,
    }
  );

  return (
    <div className='drawer-container' onClick={(e) => e.target === e.currentTarget && onClose()}>
      <Drawer position='end' mode='push' expanded={isOpen} onClose={onClose} className='rule-form-drawer'>
        <DrawerContent>
          <div className='rule-form'>
            <FormHeader formData={formData} setFormData={setFormData} editingRule={editingRule} handleDelete={handleDelete} />

            <div className='rule-form-content'>
              <NameField formData={formData} nameChangeHandler={nameChangeHandler} errors={errors} />

              <LocationsSection formData={formData} handleLocationChange={handleLocationChange} errors={errors} />

              <ConditionsSection formData={formData} handleConditionToggle={handleConditionToggle} handleConditionChange={handleConditionChange} errors={errors} />

              <ActionsSection formData={formData} actions={actions} isActionSelected={isActionSelected} handleActionChange={handleActionChange} errors={errors} editingRule={editingRule} />
            </div>

            <FormFooter onClose={onClose} handleSubmit={handleSubmit} errors={errors} editingRule={editingRule} />
          </div>
        </DrawerContent>
      </Drawer>
    </div>
  );
};

export default RuleForm;
